const all_columns = {
    transaction_id: {
        key: "transaction_id",
        display_name: "analysis:transaction:id",
        sort_key: "transaction_id"
    },
    address: {
        key: "address",
        display_name: "general:real_estate",
        sort_key: "address"
    },
    transaction_date: {
        key: "transaction_date",
        display_name: "factortype:date",
        sort_key: "transaction_date"
    },
    component_size: {
        key: "component_size",
        display_name: "general:contract:size",
        sort_key: "component_size"
    },
    sizes: {
        key: "sizes",
        display_name: "general:area:plural",
        help_icon_slug: "amas-comparable-search-ren-povrsine"
    },
    building_year_built: {
        key: "building_year_built",
        display_name: "general:year_built_and_renovations",
        sort_key: "building_year_built",
        help_icon_slug: "amas-comparable-search-leto-izgradnje-in-obnove"
    },
    transaction_amount_gross: {
        key: "transaction_amount_gross",
        display_name: "analysis:transaction:contract:price",
        sort_key: "transaction_amount_gross",
        help_icon_slug: "pogodbena-cena",
    },
    transaction_amount_m2: {
        key: "transaction_amount_m2",
        display_name: "analysis:ct:price_per_squared_meter",
        sort_key: "transaction_amount_m2",
        help_icon_slug: "pogodbena-cena-m2",
        round_to: 0,
    },
    land_quality: {
        key: "land_quality",
        display_name: "real_estate:parcel:land_quality",
        sort_key: "parcel.land_quality",
    },
    usages: {
        key: "usages",
        display_name: "real_estate:parcel:usage:actual_and_dedicated",
    },
    valuation_zone: {
        key: "valuation_zone",
        display_name: "real_estate:value_level",
        sort_key: "valuation_zone.level",
    },
    match_score: {
        key: "match_score",
        display_name: "general:match",
    },
    options_selected_comparable: {
        key: "options",
        display_name: "analysis:ct:selected_comparable",
    },
    options_wider_range: {
        key: "options",
        display_name: "analysis:ct:wider_range",
    }
}

export const all_unit_columns = [
    all_columns.transaction_id,
    all_columns.address,
    all_columns.component_size,
    all_columns.sizes,
    all_columns.building_year_built,
    all_columns.transaction_amount_gross,
    all_columns.transaction_amount_m2,
    all_columns.match_score,
    all_columns.options_selected_comparable,
    all_columns.options_wider_range,
]

export const all_parcel_columns = [
    all_columns.transaction_id,
    all_columns.address,
    all_columns.component_size,
    all_columns.usages,
    all_columns.land_quality,
    all_columns.valuation_zone,
    // all_columns.usage,
    all_columns.transaction_amount_gross,
    {
        ...all_columns.transaction_amount_m2,
        round_to: 2,
    },
    all_columns.match_score,
    all_columns.options_selected_comparable,
    all_columns.options_wider_range,
]
